import { useEffect } from 'react';
import { Keyboard } from '@capacitor/keyboard';
import { isNative } from '@/lib/platform';
import { useUIStore } from '@/stores/uiStore';

// The keyboard plugin runs with resize: 'native' (capacitor.config.ts) — the
// WebView itself shrinks above the keyboard, so bottom-anchored elements are
// lifted automatically. --keyboard-height must therefore NOT be added to a
// fixed element's bottom offset (that double-compensates and strands the
// element mid-screen — the routine-builder tab-bar bug fixed for build 16).
// The var is kept for surfaces that need the raw height; keyboardVisible in
// the uiStore is what UI should branch on (e.g. BottomTabs hides entirely).
export function useKeyboardEffect(): void {
  useEffect(() => {
    if (!isNative()) return;

    const root = document.documentElement;

    const showHandle = Keyboard.addListener('keyboardWillShow', (info) => {
      root.style.setProperty('--keyboard-height', `${info.keyboardHeight}px`);
      useUIStore.getState().setKeyboardVisible(true);
    });

    const hideHandle = Keyboard.addListener('keyboardWillHide', () => {
      root.style.setProperty('--keyboard-height', '0px');
      useUIStore.getState().setKeyboardVisible(false);
    });

    return () => {
      void showHandle.then((h) => h.remove());
      void hideHandle.then((h) => h.remove());
      root.style.removeProperty('--keyboard-height');
      useUIStore.getState().setKeyboardVisible(false);
    };
  }, []);
}
